<template>
  <div class="container">
    <van-sticky>
      <!-- 顶部 -->
      <div class="top">
        <van-icon name="arrow-left" size="20" color="var(--text_color)" @click="$router.go(-1)" />
        <!-- 编辑自选 -->
        <span> {{ $t('market').Editselfselection }}</span>
        <svg-icon class-name="svgs" icon-class="add" @click="onShowAddSelect" />
      </div>
      <!-- 产品业务 -->
      <div class="protypeTab"><span v-for="(item, index) in tabsBusiness" :key="`tabbus${index}`" :class="activeBusiness == item.value ? 'active' : ''" @click="changeBusinessTab_sel(item.value)">{{ item.name
          }}</span></div>
      <!-- 产品类型 -->
      <div class="tabs" v-if="(activeBusiness == 2||activeBusiness == 4) && tabsType.length > 2"><span v-for="(item, index) in tabsType" :key="`tabtype${index}`" :class="activeType == item.value ? 'active' : ''" @click="changeTypeTab_sel(item.value)">{{ item.name
          }}</span>
      </div>
      <!-- 标题 -->
      <div class="title"><span> {{ $t('market').product }}</span><span> {{ $t('market').operate }}</span></div>
    </van-sticky>
    <!-- 自选产品列表 -->
    <div class="info">
      <draggable v-model="selectList" handle=".drag-handle" @end="editAddSelect">
        <div v-for="(item, index) in selectList" :key="item.productId" class="item">
          <div class="left">
            <input type="checkbox" class="circle-checkbox" v-model="selectedItems" :value="item.productId" />
            <span><img :src="baseUrl + item.logoUrl" />{{ item.name }}</span>
          </div>
          <div class="right">
            <svg-icon class-name="svgs" icon-class="top" @click="moveToTop(index)" />
            <svg-icon class-name="svgs" icon-class="move" class="drag-handle" />
          </div>
        </div>
      </draggable>
    </div>
    <!-- 底部操作 -->
    <div class="footer">
      <div class="left">
        <input type="checkbox" class="circle-checkbox" v-model="selectAll" @change="toggleSelectAll" />
        <span> {{ $t('market').SelectAll }}</span>
      </div>
      <span @click="deleteSelected" :class="selectedItems.length > 0 ? '' : 'noactive'">{{ $t('market').delete }}({{
        selectedItems.length
      }})</span>
    </div>
    <!-- 添加自选 -->
    <van-popup v-model="showAddSelect" position="bottom" closeable :style="{ overflow: 'hidden' }" @close="getOptionalProductList">
      <div class="addSelectInfo">
        <!-- 顶部 -->
        <div class="tops">
          <!-- 标题 -->
          <div class="tit">{{ $t('market').Addoptional }}</div>
          <!-- 搜索 -->
          <van-search v-model="searchValue" shape="round" background="var(--background_color)" :placeholder="$t('public').search" @search="onSearch" @cancel="onSearch" @clear="onSearch" @input="onSearch" />
          <!-- 产品业务 -->
          <div class="protypeTab"><span v-for="(item, index) in tabsBusiness" :key="`tabbus${index}`" :class="activeBusiness == item.value ? 'active' : ''" @click="changeBusinessTab(item.value)">{{ item.name
              }}</span></div>
          <!-- 产品类型 -->
          <div class="tabs" v-if="(activeBusiness == 2||activeBusiness == 4) && tabsType.length > 2"><span v-for="(item, index) in tabsType" :key="`tabtype${index}`" :class="activeType == item.value ? 'active' : ''" @click="changeTypeTab(item.value)">{{ item.name
              }}</span>
          </div>
        </div>
        <!-- 产品列表 -->
        <div class="productInfo" :style="'height: calc(90vh - ' + ((activeBusiness == 2||activeBusiness == 4) && tabsType.length > 2 ? 180 : 140) + 'px);'">
          <van-list v-model="loading" :finished="finished" :loading-text="$t('public').loadingText" @load="getProductList" :immediate-check="false">
            <div class="item" v-for="(item, index) in pList" :key="`pro${index}`">
              <span><img :src="baseUrl + item.logoUrl" />{{ item.name }}</span>
              <input type="checkbox" class="circle-checkbox" v-model="pListSelectIds" :value="item.productId" @change="subAddSelect(item.productId)" />
            </div>
          </van-list>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import draggable from "vuedraggable"
import productApi from '@/api/product'
import systemApi from '@/api/system'
export default {
  components: { draggable },
  data() {
    return {
      baseUrl: window.baseURL,
      showAddSelect: false,
      searchValue: '',
      //产品业务
      activeBusiness: 1,
      tabsBusiness: [{
        name: this.$t('public').USDTcontract,
        value: 1
      },
      // {
      //   name: this.$t('public').Fiatcurrencycontract,
      //   value: 2
      // }, 
      {
        name: this.$t('public').spot,
        value: 3
      }, {
        name: this.$t('public').secondContract,
        value: 4
      }],
      //产品类型
      activeType: '',
      tabsType: [{
        name: this.$t('public').All,
        value: ""
      }],
      isRun: false,
      loading: false,
      finished: false,
      parms: {
        pageNum: 1,
        pageSize: 15,
      },
      pList: [],//产品列表
      pListSelectIds: [],//选择的产品ids
      selectList: [],//自选产品列表
      selectedItems: [],//选择的产品ids
      selectAll: false,
    };
  },
  mounted() {
    if (this.$route.query.i) {
      this.onShowAddSelect()
    }
    this.getConfig()
    this.getOptionalProductList()
  },
  methods: {
    // 展示添加自选
    onShowAddSelect() {
      this.onSearch()
      this.showAddSelect = true
    },
    // 提交添加自选
    async subAddSelect() {
      await productApi.addOptionalProduct({ productBusiness: this.activeBusiness, productType: this.activeType, productIds: this.pListSelectIds })
    },
    // 编辑自选
    async editAddSelect() {
      await productApi.addOptionalProduct({ productBusiness: this.activeBusiness, productType: this.activeType, productIds: this.selectList.map(n => n.productId) })
    },
    // 获取客户端配置 配置支持产品类型
    async getConfig() {
      this.tabsType = [{
        name: this.$t('public').All,
        value: ""
      }]
      const res = await systemApi.getConfig()
      var productType = res.productType.split(',')
      productType.forEach((sItem) => {
        switch (sItem) {
          case "1":
            this.tabsType.push({
              name: this.$t('public').DigitalCurrency,
              value: "1"
            })
            break;
          case "2":
            this.tabsType.push({
              name: this.$t('public').foreignExchange,
              value: "2"
            })
            break;
          case "3":
            this.tabsType.push({
              name: this.$t('public').futures,
              value: "3"
            })
            break;
          case "4":
            this.tabsType.push({
              name: this.$t('public').stockIndex,
              value: "4"
            })
            break;
          case "5":
            this.tabsType.push({
              name: this.$t('public').stock,
              value: "5"
            })
            break;
        }
      })
    },
    //搜索
    onSearch() {
      this.pList = []
      this.parms.pageNum = 1
      this.finished = false;
      this.getProductList()
    },
    //切换产品业务
    changeBusinessTab(val) {
      this.activeBusiness = val
      if (this.activeBusiness != 2 && this.activeBusiness != 4)
        this.activeType = ''
      this.onSearch()
    },
    //切换产品类型
    changeTypeTab(val) {
      this.activeType = val
      this.onSearch()
    },
    //切换产品业务自选列表
    changeBusinessTab_sel(val) {
      this.activeBusiness = val
      if (this.activeBusiness != 2 && this.activeBusiness != 4)
        this.activeType = ''
      this.getOptionalProductList()
    },
    //切换产品类型自选列表
    changeTypeTab_sel(val) {
      this.activeType = val
      this.getOptionalProductList()
    },
    // 获取自选产品列表
    async getOptionalProductList() {
      var parms = {}
      parms.pageNum = 1
      parms.pageSize = 1000
      parms.productBusiness = this.activeBusiness
      parms.productType = this.activeType
      const res = await productApi.getOptionalProductList(parms)
      this.selectList = res.rows
      this.pListSelectIds = res.rows.map(item => item.productId)
    },
    // 获取产品列表
    async getProductList() {
      if (this.isRun) return
      this.isRun = true
      this.parms.productBusiness = this.activeBusiness
      this.parms.productType = this.activeType
      this.parms.name = this.searchValue
      const res = await productApi.getProductList(this.parms)
      this.pList.push(...res.rows);
      this.getOptionalProductList()
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      this.loading = false;
      // 数据全部加载完成
      if (this.pList.length >= res.total)
        this.finished = true;
    },
    // 置顶
    moveToTop(index) {
      const item = this.selectList.splice(index, 1)[0];
      this.selectList.unshift(item);
      this.editAddSelect()
    },
    // 全选
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedItems = this.selectList.map(item => item.productId);
      } else {
        this.selectedItems = [];
      }
    },
    // 删除
    deleteSelected() {
      this.selectList = this.selectList.filter(item => !this.selectedItems.includes(item.productId));
      this.selectedItems = [];
      this.selectAll = false;
      this.editAddSelect()
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  background: var(--background_color);

  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px;
    width: 100%;
    background: var(--background_color);
    z-index: 1000;

    font-size: 15px;
    font-weight: bold;
    color: var(--text_color);

    .svgs {
      width: 22px;
      height: 22px;
      color: var(--text_color);
    }
  }

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background: var(--background_color);
    z-index: 1000;
    padding: 15px;
    font-size: 12px;
    color: var(--ntext_color);
  }

  .protypeTab {
    padding: 12px 15px;
    font-size: 14px;
    font-weight: bold;
    color: var(--ntext_color);
    background: var(--background_color);
    border-bottom: 1px solid var(--info_color);

    span {
      margin-right: 20px;
    }

    .active {
      color: var(--text_color);
      padding-bottom: 10px;
      border-bottom: 2px solid var(--text_color);
    }
  }

  .tabs {
    display: flex;
    align-items: center;
    color: var(--ntext_color);
    background: var(--background_color);
    font-size: 13px;
    padding: 8px 15px;
    border-bottom: 1px solid var(--info_color);

    span {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 5px 10px;
      margin-right: 10px;
    }

    .active {
      background: var(--info_color);
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 5px 10px;
      color: var(--text_color);
    }
  }

  .info {
    padding: 0 15px 70px 15px;

    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 15px 0;

      .left {
        width: 70%;
        color: var(--text_color);
        font-size: 14px;
        font-weight: bold;
        display: flex;
        align-items: center;

        span {
          padding-top: 2px;
          margin-left: 10px;
          display: flex;
          align-items: center;

          img {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            margin-right: 10px;
          }
        }
      }

      .right {
        width: 20%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .svgs {
          width: 15px;
          height: 15px;
          color: var(--ntext_color);
        }

        .drag-handle {
          cursor: grab;
        }
      }
    }
  }

  .footer {
    bottom: 0;
    position: fixed;
    padding: 15px;
    width: 100%;
    background: var(--background_color);
    z-index: 1000;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    color: var(--text_color);

    .left {
      display: flex;
      align-items: center;

      span {
        margin-left: 10px;
      }
    }

    .noactive {
      color: var(--ntext_color);
    }
  }

  .addSelectInfo {
    height: 90vh;

    .tops {
      .tit {
        margin: 15px;
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        color: var(--text_color);
      }

      .protypeTab {
        padding: 12px 15px;
        font-size: 14px;
        font-weight: bold;
        color: var(--ntext_color);
        border-bottom: 1px solid var(--info_color);

        span {
          margin-right: 20px;
        }

        .active {
          color: var(--text_color);
          padding-bottom: 10px;
          border-bottom: 2px solid var(--text_color);
        }
      }

      .tabs {
        display: flex;
        align-items: center;
        color: var(--ntext_color);
        font-size: 13px;
        padding: 8px 15px;
        border-bottom: 1px solid var(--info_color);

        span {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 5px 10px;
          margin-right: 10px;
        }

        .active {
          background: var(--info_color);
          border-radius: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 5px 10px;
          color: var(--text_color);
        }
      }
    }

    .productInfo {
      padding: 0 15px 15px 15px;
      // height: 70vh;
      overflow-y: scroll;

      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 0;
        color: var(--text_color);
        font-size: 14px;
        font-weight: bold;

        span {
          display: flex;
          align-items: center;

          img {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            margin-right: 10px;
          }
        }
      }
    }
  }
}

::v-deep .van-search__content {
  background-color: var(--info_color);
}

::v-deep .van-cell {
  color: var(--text_color);
}

::v-deep .van-field__control {
  color: var(--text_color);
}

::v-deep .van-popup--bottom {
  border-radius: 15px 15px 0 0;
  background: var(--background_color);
}

::v-deep .van-popup__close-icon {
  font-size: 18px;
  color: var(--ntext_color);
}

.circle-checkbox {
  appearance: none;
  /* 移除默认样式 */
  -webkit-appearance: none;
  /* Safari 兼容性 */
  width: 15px;
  /* 圆的直径 */
  height: 15px;
  /* 圆的直径 */
  border: 1px solid var(--ntext_color);
  /* 边框颜色 */
  border-radius: 50%;
  /* 圆形样式 */
  background-color: var(--background_color);
  /* 默认背景色 */
  cursor: pointer;
  position: relative;
  transition: background-color 0.3s ease;
}

.circle-checkbox:checked {
  background-color: var(--text_color);
  /* 选中时背景色 */
  border-color: var(--text_color);
  /* 选中时边框色 */
}

.circle-checkbox:checked::after {
  content: '✓';
  /* 显示对号 */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: var(--background_color);
  /* 对号颜色 */
  font-size: 8px;
  /* 对号大小 */
}
</style>